import { FormActionType, Pais, PaisDocumento, TiposDocumento } from "@rpe/registro-personas-empresas-lib";

export interface DocumentoPersona {
  id: number;
  pais_codigo: string;
  tipo_documento_codigo: number;
  numero: number;
}

export function createEmptyDocumentoPersona(): DocumentoPersona {
  return {
    id: null,
    pais_codigo: null,
    tipo_documento_codigo: null,
    numero: null
  };
}

export function createDocumentoPersona(params: any): DocumentoPersona {
  return {
    ...createEmptyDocumentoPersona(),
    ...params
  };
}

// form
export interface DocumentoPersonaFormInput {
  action: FormActionType;  
  documento_persona: DocumentoPersona;  
}

export function createEmptyDocumentoPersonaFormInput(): DocumentoPersonaFormInput {
  return {
    action: FormActionType.Add,    
    documento_persona: createEmptyDocumentoPersona(),    
  };
}

// Initial set
export interface DocumentoPersonaSet {
  paises: Pais[],
  tiposDocumento: TiposDocumento[],
  paisesDocumento: PaisDocumento[]  
}

export function createEmptyDocumentoPersonaSet(): DocumentoPersonaSet {
  return {        
      paises: null,
      tiposDocumento: null,
      paisesDocumento: null      
  };
}

export function createDocumentoPersonaSet(params: any): DocumentoPersonaSet {
  return {
    ...createEmptyDocumentoPersonaSet(),
    ...params
  };
}